// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".count-items-tab{font-size:16px;line-height:24px;margin:0;color:#7d8290}", ""]);
// Exports
module.exports = exports;
